// Copyright (c) 2022 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import {FormattedMessage} from 'react-intl';
import PercentageDebitInfoPanel from './percentage-debit-info-panel';
import PercentageDebitModal from './percentage-debit-modal';
import PercentageInfoScreen from './percentage-screen/percentage-info-screen';
import PercentageScreen from './percentage-screen/percentage-screen';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

function onConfirm() {

    const endPoint = 'https://dlrdoc.deere.com/ag_cust_supp/claimDebit';

    window.open(endPoint, '_blank');

    this.goBack();

}
function handleConfirmationModalClose() {

    this.actions.updateConfirmationModalVisibility(false);
    this.goBack();

}

function openPercentageDebitModal() {

    this.actions.updatePercentageDebitModalVisibility(true);

}
function cancelPercentageDebit() {

    this.actions.completePercentageDebit(this.queryParams.auditNumber);

}
function handlePercentageChange(value) {

    if (value === '' || this.debit.partialDebit.length > 0) {

        this.debit.partialDebit.forEach(debit => {

            debit.valueOfAdjustment = value;

        });

        this.actions.updatePercentage(this.debit.partialDebit);

    }

}
function handlePercentageCalc() {

    const per = ((this.debit.partialDebit[0].valueOfAdjustment / 100) * this.debit.netAmountPaid);

    this.actions.calculatePercentage(per);

}

class PercentageDebit extends Component {

    componentWillMount() {

        if (this.props.queryParams.claimNumber) {

            this.props.actions.readPercentageDebit(this.props.queryParams.claimNumber);

        }

    }
    componentWillUnmount() {

        this.props.actions.updatePercentageDebitModalVisibility(false);
        this.props.actions.updateConfirmationModalVisibility(false);
        this.props.actions.resetPercentageDebit();

    }

    render() {

        const valueOfAdjustment = this.props.debit.partialDebit.length > 0 ? this.props.debit.partialDebit[0].valueOfAdjustment : '';
        const isSpecialAllowanceClaim = this.props.debit.claimType.key === 'ZSPA' && this.props.debit.specialAllowanceType.key !== '12';

        return (
            <section className='percentage-debit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='percentage-debit-header'>
                    <h2>
                        <FormattedMessage
                            id='DEBIT_FOR_CLAIM_NUMBER'
                            values={{
                                claimNumber: formatClaimNumber(this.props.debit.claimNumber)
                            }}
                        />
                    </h2>
                    <div className='button-group'>
                        <button
                            onClick={this.props::cancelPercentageDebit}
                        >
                            <FormattedMessage id='CANCEL'/>
                        </button>
                        <button
                            className='primary'

                            disabled={!this.props.amountDebit && !this.props.debit.valueOfAdjustment}

                            onClick={this.props::openPercentageDebitModal}
                        >
                            <FormattedMessage id='SUBMIT'/>
                        </button>
                    </div>
                </div>
                <PercentageDebitInfoPanel/>

                {!isSpecialAllowanceClaim && this.props.debit.partialDebit.length > 0 ?
                    <div>
                        <PercentageScreen
                            onApplyClick={this.props::handlePercentageCalc}
                            onPercentageChange={this.props::handlePercentageChange}
                            percentage={valueOfAdjustment}
                        />
                        <PercentageInfoScreen
                            amountDebit={this.props.amountDebit}
                            netAmountPaid={this.props.debit.netAmountPaid}
                        />
                    </div> : null
                 }
                <ConfirmationModal
                    confirmMessage='DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS'
                    isOpen={this.props.isConfirmationModalVisible}
                    onClose={this.props::handleConfirmationModalClose}
                    onConfirm={this.props::onConfirm}
                    title='PERCENTAGE_DEBIT'
                />
                {
                    <PercentageDebitModal
                        amountDebit={this.props.amountDebit}
                        queryParams={this.props.queryParams}
                    />
                 }
            </section>
        );

    }
}

PercentageDebit.displayName = 'PercentageDebitModalContainer';
PercentageDebit.propTypes = {
    actions: PropTypes.object.isRequired,
    amountDebit: PropTypes.number.isRequired,
    busyCounter: PropTypes.number.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    goBack: PropTypes.func.isRequired,
    isConfirmationModalVisible: PropTypes.bool.isRequired,
    percentage: PropTypes.number.isRequired,
    queryParams: PropTypes.object.isRequired

};

export default PercentageDebit;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-debit.js